module.exports = __webpack_public_path__ + "static/img/6.4237714.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/eng/6.png
// module id = TUWW
// module chunks = 0